module.exports = __webpack_public_path__ + "static/img/mouse.e7b9eaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/mouse.png
// module id = oF/8
// module chunks = 1